import { Box, Typography } from "@mui/material";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import RelatedUserSection from "./RelatedUserSection";

const GitHubOrgTokenDetailsView = ({ entityData }) => {
  const repositorySelectionMap = {
    none: "The token can access only public repositories",
    all: "The token can access all repositories, including private repositories",
    subset: "",
  };

  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      {entityData?.github_pat_data?.owner_login && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Owner</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.github_pat_data?.owner_login}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.connected_email && (
        <RelatedUserSection
          entityData={entityData}
          contextName="github org token - nhi details view"
        />
      )}
      {entityData?.github_pat_data?.repository_selection && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Repositories</Typography>
          </Box>
          <Box ml={2} display={"flex"} flexDirection={"column"} gap={1}>
            <TextIntegrationStyle
              title={""}
              value={
                repositorySelectionMap[
                  entityData.github_pat_data.repository_selection
                ]
              }
            ></TextIntegrationStyle>
            {entityData.github_pat_data.repository_selection === "subset" &&
              Object.entries(entityData.github_pat_data.repositories_list).map(
                ([index, permission]) => (
                  <Box
                    key={index}
                    display={"flex"}
                    flexDirection={"row"}
                    alignItems={"center"}
                    gap={1}
                  >
                    <TextIntegrationStyle
                      title={""}
                      value={permission}
                    ></TextIntegrationStyle>
                  </Box>
                )
              )}
          </Box>
        </Box>
      )}
      {entityData?.github_pat_data?.permissions && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Permissions</Typography>
          </Box>
          <Box ml={2} display={"flex"} flexDirection={"column"} gap={1}>
            {Object.entries(entityData.github_pat_data.permissions).map(
              ([index, permission]) => (
                <Box
                  key={index}
                  display={"flex"}
                  flexDirection={"row"}
                  alignItems={"center"}
                  gap={1}
                >
                  <TextIntegrationStyle
                    title={""}
                    value={permission}
                  ></TextIntegrationStyle>
                </Box>
              )
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default GitHubOrgTokenDetailsView;
